"use client";
import { type FC, useState } from "react";
import { ospThemes, Icon } from "@ospweb/sdk-ui";
import { cn } from "utils";
import { useParams } from "next/navigation";
import useScrollCheck from "../hooks/useScrollCheck";
import { useChatUpdate } from "../hooks";
import { MenuModal } from "./Menu";
import Translations from "@translate/components/Header";
import { I18nUtil } from "@utils";
const I18n = I18nUtil.createScoped(Translations);
interface HeaderProps {
  className?: string;
  isOperable?: boolean;
  onShare?: () => void;
  onGo?: () => void;
  mark?: 0 | 1;
  isExtension?: boolean;
}

export const Header: FC<HeaderProps> = ({
  onShare,
  className,
  isOperable = true,
  mark,
  isExtension,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const isScrolled = useScrollCheck("container");
  const onCancel = () => {
    setIsOpen(false);
  };
  const { handleUpdateChat, isLoading } = useChatUpdate();
  const { chatId } = useParams() || {};

  const handleStarClick = async () => {
    if (isLoading) {
      return;
    }
    await handleUpdateChat({
      params: {
        id: chatId as string,
        mark: mark === 1 ? 0 : 1,
      },
    });
  };
  const handleShareChat = (e: React.MouseEvent) => {
    onShare?.();
    e.stopPropagation();
    e.preventDefault();
  };
  return (
    <>
      <header
        aria-label="Header header"
        data-openreplay-label="Header header Semantic"
        id="sem-header-header"
        className={cn(className)}
      >
        {isOperable && (
          <div
            className={cn(
              "flex items-center gap-4 md:mr-0 mr-6",
              isExtension && "mr-0",
            )}
          >
            <div
              data-openreplay-label="Header · div"
              className="flex items-center justify-center md:gap-[2px] gap-5 md:py-2 md:px-3 p-[6px] cursor-pointer md:bg-transparent bg-background_white_overlay10 rounded-xl"
              onClick={handleStarClick}
            >
              <Icon
                name={mark === 1 ? "start-fill" : "star"}
                size={20}
                className={cn("cursor-pointer text-content_primary", {
                  "text-content_brand_primary": mark === 1,
                })}
              />
              <span className="text-content_primary button_m md:block hidden">
                {I18n.t("Save Chat")}
              </span>
            </div>
            <div
              data-openreplay-label="Header · div"
              className="flex items-center justify-center md:gap-[2px] gap-5 md:py-2 md:px-3 p-[6px] cursor-pointer md:bg-transparent bg-background_white_overlay10 rounded-xl"
              onClick={handleShareChat}
            >
              <Icon
                name="export"
                size={20}
                className="vertical-middle"
                color={ospThemes.colors.content_primary}
              />
              <span className="text-content_primary button_m md:block hidden">
                {I18n.t("Share Session")}
              </span>
            </div>
          </div>
        )}
        <div
          className={cn(
            "w-full h-6 absolute top-60px left-0 right-0 z-1000 hidden pointer-events-none",
            { block: isScrolled },
          )}
        />
      </header>
      <MenuModal isOpen={isOpen} onCancel={onCancel} />
    </>
  );
};
